import AppRecord from './AppRecord.js'

class DataSelector extends AppRecord {
}
export default DataSelector
